import {
  ActionBar,
  ChakraBox,
  FAIconName,
  useToastMessage,
} from '@equip.health/ui';
import { useState } from 'react';
import { useInvitePatientMutation } from '~/store/services/patients';

interface ResendEmailLinkActionBarProps {
  showResendInvitation: boolean;
  id: string;
  patientName: string;
  patientId: string;
}

const ResendEmailLinkActionBar = (details: ResendEmailLinkActionBarProps) => {
  const { showResendInvitation, id, patientName, patientId } = details;

  const { createToast } = useToastMessage();
  const [isResendMailSent, setIsResendMailSent] = useState<boolean>(false);
  const [resendPasswordCreationEmail] = useInvitePatientMutation();

  const showActionBar = showResendInvitation && !isResendMailSent;

  const handleResendPasswordCreationMail = (patientId: string) => {
    resendPasswordCreationEmail(patientId)
      .unwrap()
      .then(() => {
        setIsResendMailSent(true);
        createToast({
          icon: FAIconName.checkRegular,
          id: `${id}-success_toast`,
          text: 'Email resent',
          variant: 'success',
        });
      })
      .catch(() => {
        createToast({
          icon: FAIconName.exclamationTriangleRegular,
          id: `${id}-error_toast`,
          text: "We're sorry, we were unable to send the email at this time. Please try again.",
          variant: 'critical',
        });
      });
  };
  return (
    showActionBar && (
      <ChakraBox marginTop="18px">
        <ActionBar
          barIcon={FAIconName.exclamationTriangleRegular}
          buttonIcon={FAIconName.redoRegular}
          buttonText="Resend password creation email"
          id={id}
          onButtonClick={() => handleResendPasswordCreationMail(patientId)}
          size="medium"
          text={`${patientName} has not created an account password yet`}
          variant="warning"
        />
      </ChakraBox>
    )
  );
};

export default ResendEmailLinkActionBar;
